import React from 'react'

import RenderExceptionContent from 'components/work-order/details/exceptions/RenderExceptionContent'

import type { SxProps, Theme } from '@mui/material/styles'

type RenderExceptionProps = {
  ImageSx?: SxProps<Theme>
  height?: string | number
  isSignExceptionType?: boolean
  base64Data?: string
  PageProps?: Record<string, unknown>
}

const RenderException = ({ isSignExceptionType, ImageSx, height, base64Data, PageProps }: RenderExceptionProps) => {
  if (isSignExceptionType) {
    return <RenderExceptionContent isPdf height={height} PageProps={PageProps} src={base64Data} sx={ImageSx} title="PDF Document" />
  }
  return <RenderExceptionContent height={height} loading="lazy" src={base64Data} sx={ImageSx} />
}

export default RenderException
